import ScrollToTop from "./scrollToTop";
import ChangeLang from "./changeLang";
import WorkerDetails from "./workerDetails.vue";

export { ScrollToTop, WorkerDetails, ChangeLang };
